<div *ngIf="!displayUserManagement">
<app-search-result></app-search-result>
</div>
<div *ngIf="displayUserManagement">
  <app-user-management ></app-user-management>
</div>
